import React, { Component } from 'react';

import { Header, Navbar, NavPills } from '@C';
import { RouteSetup } from '@C/Director/Utils';
import ErrorBoundary from '@C/Error';
import { authService } from '@S';

const routes = [
  {
    name: 'OMC',
    path: '/crm/omc',
  },
  {
    name: 'Fuels',
    path: '/crm/fuels',
  },
  {
    name: 'Products Catogories',
    path: '/crm/product-catogories',
  },
  {
    name: 'Shifts',
    path: '/crm/shifts',
  },
  {
    name: 'Bank Account Type',
    path: '/crm/bank-account-type',
  },
  {
    name: 'Banks',
    path: '/crm/banks',
  },
  {
    name: 'Swipe Machines',
    path: '/crm/swipe-machines',
  },
  {
    name: 'Wallets',
    path: '/crm/wallet',
  },
];

class Utils extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Referral program" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <div className="page-title"></div>
              <ErrorBoundary>
                <NavPills routes={routes} />
              </ErrorBoundary>
              <ErrorBoundary>
                <RouteSetup />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { Utils };
